const PAYMENT_IMAGE = "/assets/payment-security-premium.jpg";

export default function PaymentTrust({ compact = false }) {
  return (
    <div className={`payment-trust-image ${compact ? "payment-trust-image--compact" : ""}`} data-testid="payment-trust">
      <img
        src={PAYMENT_IMAGE}
        alt="Paiement sécurisé — Visa, Mastercard, PayPal, Apple Pay, Google Pay et Stripe"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
